import { render } from "./DiretoryIcon.vue?vue&type=template&id=d8c08c50&scoped=true"
import script from "./DiretoryIcon.vue?vue&type=script&lang=js"
export * from "./DiretoryIcon.vue?vue&type=script&lang=js"

import "./DiretoryIcon.vue?vue&type=style&index=0&id=d8c08c50&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8c08c50"]])

export default __exports__